const buttonGroup = (tokens) => {
    const { component: { buttonArray }, } = tokens;
    return {
        MuiButtonGroup: {
            defaultProps: {
                disableRipple: true,
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    padding: 0,
                    gap: buttonArray.gap.value,
                    "& .MuiButtonGroup-firstButton, & .MuiButtonGroup-middleButton": {
                        borderTopRightRadius: "inherit",
                        borderBottomRightRadius: "inherit",
                        borderRightColor: "inherit",
                    },
                    "& .MuiButtonGroup-lastButton, & .MuiButtonGroup-middleButton": {
                        borderTopLeftRadius: "inherit",
                        borderBottomLeftRadius: "inherit",
                        marginLeft: 0,
                    },
                },
            },
        },
    };
};
export default buttonGroup;
//# sourceMappingURL=buttonGroup.js.map